module.exports = __webpack_public_path__ + "static/flickr-stream-77ae317f08da91d7ab94bf0c9e76ccef.png";